import { Block, Tabs } from '@uni-space/uni-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Parcels from '@features/Parcels/ui/Parcels';
import BulkCancelParcels from '@features/Parcels/ui/BulkCancelParcels';
import CancellationPhotoCapture from '@features/Parcels/ui/CancellationPhotoCapture';

enum ParcelTab {
  List = 'list',
  BulkCancel = 'bulkCancel',
  CancellationPhoto = 'cancellationPhoto',
}

export default function ParcelPage() {
  const { t } = useTranslation();
  const [tab, setTab] = useState<ParcelTab>(ParcelTab.List);

  return (
    <>
      <Block sx={{ maxWidth: 900, marginBottom: 8 }}>
        <Tabs
          value={tab}
          onChange={(id) => setTab(id as ParcelTab)}
          items={[
            { id: ParcelTab.List, label: t('parcelsPage.tabs.list') },
            { id: ParcelTab.BulkCancel, label: t('parcelsPage.tabs.bulkCancel') },
            { id: ParcelTab.CancellationPhoto, label: t('parcelsPage.tabs.cancellationPhoto') },
          ]}
        />
      </Block>
      {tab === ParcelTab.List && <Parcels />}
      {tab === ParcelTab.BulkCancel && <BulkCancelParcels />}
      {tab === ParcelTab.CancellationPhoto && <CancellationPhotoCapture />}
    </>
  );
}
